/*
 * @Description: 
 * @Author: JokerShaw
 * @Date: 2023-06-07 13:49:30
 * @LastEditTime: 2023-06-26 11:32:18
 * @FilePath: \yd_yg_test_project_new\src\components\Pages\Guide\GuideCarousel\index.js
 */
import React, { Fragment, } from 'react'
import { Carousel } from 'antd';
import Notice from './notice'
import News from './news'
// import Statistics from './statistics'
import Introduce from './introduce'
import './style.css'
export default function GuideCarousel(props) {
    const { noticeDatas, newsDatas, statisticsDatas, introduceDatas } = props;
    return (
        <Carousel className='GuideCarousel' autoplay={true} autoplaySpeed={5000} speed={1000} infinite>
            <Notice data={noticeDatas} />
            <News data={newsDatas} />
            {/* <Statistics data={statisticsDatas} /> */}
            <Introduce data={introduceDatas} />
        </Carousel>
    )
}